export default "__VITE_ASSET__BAZgDH$R__"